import { defineComponent as _defineComponent } from 'vue'
import { withModifiers as _withModifiers, mergeProps as _mergeProps, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import {onBeforeUnmount,watch} from 'vue'
import AdminImage from './AdminImage.vue'
import AdminImagePreview from './AdminImagePreview.vue'
import product from '@/api/product'
import store from '@/store'
import {createProductImageGallery} from '@/utils/productImageGallery'
const __default__ = {inheritAttrs:false}
export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'ProductImage',
  props: {
    src: {},
    width: {},
    height: {},
    productId: {},
    attachments: {},
    baseUrl: {},
    title: {}
  },
  setup(__props: any) {

const props=__props
const {state,open:openGallery,close,move}=createProductImageGallery(async id=>{
  const response=await product.getProductAttachs(id,0)
  if(!Array.isArray(response.data))throw new Error('Invalid product images')
  return response.data
},()=>props.baseUrl || store.getters.settings?.imgurl?.value || '')
function open(){return openGallery(props.src || '',props.productId,props.attachments)}
watch(()=>[props.src,props.productId,props.attachments,props.baseUrl],close,{flush:'sync'})
onBeforeUnmount(close)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AdminImage, _mergeProps(_ctx.$attrs, {
      src: _ctx.src,
      alt: _ctx.title || '商品图片',
      width: _ctx.width,
      height: _ctx.height,
      preview: false,
      onClick: _withModifiers(open, ["stop"])
    }), null, 16, ["src", "alt", "width", "height"]),
    (_unref(state).visible)
      ? (_openBlock(), _createBlock(AdminImagePreview, {
          key: 0,
          visible: _unref(state).visible,
          src: _unref(state).sources[_unref(state).index] || '',
          title: _ctx.title || '商品图片',
          count: _unref(state).sources.length,
          index: _unref(state).index,
          busy: _unref(state).busy,
          error: _unref(state).error,
          onPrevious: _cache[0] || (_cache[0] = ($event: any) => (_unref(move)(-1))),
          onNext: _cache[1] || (_cache[1] = ($event: any) => (_unref(move)(1))),
          onClose: _unref(close)
        }, null, 8, ["visible", "src", "title", "count", "index", "busy", "error", "onClose"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})